import type { App } from '../app';
import type { Store } from '../state/store';
import { h } from './dom';

export function renderLogin(root: HTMLElement, app: App, store: Store): void {
  root.replaceChildren();
  const alert = h('p', { role: 'alert', class: 'alert' });
  const durchwahl = h('input', { name: 'durchwahl', inputmode: 'numeric', autocomplete: 'username', required: '', placeholder: 'z. B. 12' });
  const password = h('input', { name: 'password', type: 'password', autocomplete: 'current-password', required: '' });
  const remember = h('input', { name: 'remember', type: 'checkbox' });
  const form = h(
    'form',
    { class: 'card login', novalidate: '' },
    h('h1', {}, 'DLRG Telefon'),
    h('label', {}, 'Durchwahl', durchwahl),
    h('label', {}, 'SIP-Passwort', password),
    h('label', { class: 'check' }, remember, 'Angemeldet bleiben'),
    h('button', { type: 'submit', class: 'primary' }, 'Anmelden'),
    alert,
  );
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    alert.textContent = app.login(durchwahl.value, password.value, remember.checked) ?? '';
  });
  const showMessage = () => {
    const msg = store.getState().message;
    if (msg) alert.textContent = msg;
  };
  store.subscribe(showMessage);
  showMessage();
  root.append(form);
}
